export const rules = {
    name: [
        { required: true, message: 'Пожалуйста, введите вид травмы ', trigger: 'blur' },
    ],
};
